import { useEffect } from "react";

export default function useUpdateLogger(value: any, varName: string) {
  useEffect(() => {
    console.log(`${varName}: `, value);
  }, [value]);
}
